export const ApplicationResultsApiUrls = {
  demoResults: "test/GetDemoResults",
  removeTests: "test/deletetestresults",
  getApplicationResults: "application/getApplicationResults", //applicationTypeEnum , applicationId , startDate , endDate
  getApplications: "application/getApplications", // parametre yok
};

export default class ApplicationResultsAPI {
  constructor(httpsClient, cache) {
    this.httpsClient = httpsClient;
    this.cache = cache;
  }

  /*
    async demoResults(data, token) {
      return this.get(ApplicationResultsApiUrls.demoResults, data, token);
    }*/

  async removeTests(data, token) {
    return this.get(ApplicationResultsApiUrls.removeTests, data, token);
  }

  async getApplicationResults(data, token) {
    return this.get(ApplicationResultsApiUrls.getApplicationResults, data, token);
  }

  async getApplications(data, token) {
    return this.get(ApplicationResultsApiUrls.getApplications, data, token);
  }

  async get(url, data, token, eAlert, sAlert) {
    return await this.httpsClient.get(url, data, token, eAlert, sAlert);
  }

  async post(url, data, token, eAlert, sAlert) {
    return await this.httpsClient.post(url, data, token, eAlert, sAlert);
  }
}


/*
 test 
ApplicationType = ApplicationTypeEnum.Test,
  ApplicationId = x.TestId,
  ApplicationName = x.TestName,
  ResultId = x.Id,
  CompanyId = x.Ticket.CompanyId,
  CreationDate = x.Ticket.CreatedAt,
  CandidateId = x.Ticket.CandidateId,
  Name = x.Ticket.Candidate.Name,
  School = x.Ticket.Candidate.Demography.School,
  Gender = x.Ticket.Candidate.Demography.Gender,
  BirthYear = x.Ticket.Candidate.Demography.BirthYear,
  Experience = x.Ticket.Candidate.Demography.Experience,
  Faculty = x.Ticket.Candidate.Demography.Faculty,
  Department = x.Ticket.Candidate.Demography.Department,
  QuestionAnswersJson = x.QuestionAnswersJson,


envanter 
  ApplicationType = ApplicationTypeEnum.Test,
  ApplicationId = x.InventoryId,
  ApplicationName = x.InventoryName,
  ResultId = x.Id,
  CompanyId = x.Ticket.CompanyId,
  CreationDate = x.Ticket.CreatedAt,
  CandidateId = x.Ticket.CandidateId,
  Name = x.Ticket.Candidate.Name,
  School = x.Ticket.Candidate.Demography.School,
  Gender = x.Ticket.Candidate.Demography.Gender,
  BirthYear = x.Ticket.Candidate.Demography.BirthYear,
  Experience = x.Ticket.Candidate.Demography.Experience,
  Faculty = x.Ticket.Candidate.Demography.Faculty,
  Department = x.Ticket.Candidate.Demography.Department,
  QuestionAnswersJson = x.QuestionAnswersJson,
  CheckboxAnswersJson = x.CheckboxAnswersJson,*/
